jQuery(document).ready(function($) {

	$('.featured-posts--masonry').each(function() {

		// var grid = $(this).find('.featured-posts--content');

		// console.log(window.masonry());
		
		// $('.featured-posts--content').masonry({
		//   itemSelector    : '.featured-post',
		//   percentPosition : true
		// });

	});

});